import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

const IMG = `${process.env.PUBLIC_URL}/images`;
const MIMG = `${IMG}/Media`;

const stats = [
  { icon: 'file-text', value: '150+', label: 'Media Features', color: '#ec4899' },
  { icon: 'users', value: '75+', label: 'Press Releases', color: '#a855f7' },
  { icon: 'globe', value: '50+', label: 'Publications Covered', color: '#38bdf8' },
  { icon: 'calendar', value: '10+', label: 'Industry Events', color: '#ec4899' },
  { icon: 'trending-up', value: '5', label: 'Purpose-led Brands', color: '#d9a94e' },
];

const news = [
  {
    pub: 'The Economic Times',
    pubClass: 'pub-et',
    date: 'May 10, 2024',
    title: 'Caladium Systems builds an AI-first celebration ecosystem spanning five purpose-led brands',
  },
  {
    pub: 'YourStory',
    pubClass: 'pub-ys',
    date: 'Apr 28, 2024',
    title: 'From Digital to Meaningful: Caladium Systems is redefining how India celebrates',
  },
  {
    pub: 'ET Brand Equity',
    pubClass: 'pub-etbe',
    date: 'Apr 15, 2024',
    title: 'Caladium Systems on a mission to spread joy everywhere',
  },
  {
    pub: 'mint',
    pubClass: 'pub-mint',
    date: 'Mar 30, 2024',
    title: 'The rise of ecosystem-led brands in India’s celebration industry',
  },
  {
    pub: 'Forbes',
    pubClass: 'pub-forbes',
    date: 'Mar 18, 2024',
    title: 'Purpose. People. Platforms. The Caladium Systems playbook for impact',
  },
];

const pressKit = [
  { title: 'Company Overview', meta: 'PDF · 1.2 MB', icon: 'file-text' },
  { title: 'Brand Portfolio', meta: 'PDF · 2.4 MB', icon: 'file-text' },
  { title: 'Leadership Team', meta: 'PDF · 1.8 MB', icon: 'users' },
  { title: 'High Resolution Logo', meta: 'ZIP · 5.6 MB', icon: 'image' },
  { title: 'Brand Images', meta: 'ZIP · 12.3 MB', icon: 'image' },
];

const resources = [
  { icon: 'leaf', title: 'Logos', cta: 'Download', color: '#ec4899' },
  { icon: 'image', title: 'Image Gallery', cta: 'View All', color: '#38bdf8' },
  { icon: 'play', title: 'Videos', cta: 'Watch', color: '#ef4444' },
  { icon: 'file-text', title: 'Fact Sheet', cta: 'Download', color: '#38bdf8' },
  { icon: 'user', title: 'CEO Photos', cta: 'Download', color: '#d9a94e' },
  { icon: 'folder', title: 'Brand Assets', cta: 'Download', color: '#ec4899' },
];

const engagements = [
  {
    month: 'JUN',
    day: '15',
    title: 'World AI Show 2024',
    place: 'Bengaluru, India',
  },
  {
    month: 'JUL',
    day: '08',
    title: 'IAMAI India Digital Summit',
    place: 'New Delhi, India',
  },
  {
    month: 'AUG',
    day: '22',
    title: 'NASSCOM Design & Innovation Conclave',
    place: 'Mumbai, India',
  },
];

export default function Media() {
  const [email, setEmail] = useState('');

  const onSubscribe = (e) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <div className="md-page">
      {/* =================== HERO =================== */}
      <section className="md-hero">
        <div
          className="md-hero__bg"
          style={{ backgroundImage: `url(${MIMG}/Media.jpeg)` }}
        />
        <div className="container container--wide md-hero__inner">
          <div className="md-hero__copy">
            <span className="eyebrow">MEDIA CENTER</span>
            <h1 className="md-hero__title">
              Stories That Inspire.
              <br />
              <span className="grad-pink">Impact That Matters.</span>
            </h1>
            <p className="md-hero__lead">
              Welcome to the official media hub of Caladium Systems. Find our
              latest announcements, news coverage, media resources and stories
              that highlight our purpose, people and progress.
            </p>
            <div className="md-hero__actions">
              <Link to="#news" className="btn btn--primary">
                Press Release <Icon name="arrow-up-right" size={16} />
              </Link>
              <Link to="/contact" className="btn btn--ghost">
                Media Contact <Icon name="mail" size={15} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* =================== STATS BAR =================== */}
      <section className="md-stats-sec">
        <div className="container container--wide">
          <div className="md-stats">
            {stats.map((s) => (
              <div className="md-stat" key={s.label}>
                <span
                  className="md-stat__icon"
                  style={{ color: s.color, borderColor: s.color }}
                >
                  <Icon name={s.icon} size={26} />
                </span>
                <div className="md-stat__text">
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =================== IN THE NEWS =================== */}
      <section className="md-news-sec" id="news">
        <div className="container container--wide">
          <header className="md-news__head">
            <div className="md-news__title">
              <h2 className="h2">In The News</h2>
              <span className="md-news__line" />
            </div>
            <a href="#all" className="md-news__more">
              View All News <Icon name="arrow-right" size={14} />
            </a>
          </header>

          <div className="md-news__grid">
            {news.map((n) => (
              <article className="md-news__card" key={n.title}>
                <div className={`md-news__pub ${n.pubClass}`}>{n.pub}</div>
                <span className="md-news__date">{n.date}</span>
                <h3 className="md-news__headline">{n.title}</h3>
                <a href="#read" className="md-news__link">
                  Read More <Icon name="arrow-right" size={13} />
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =================== PRESS KIT + RESOURCES =================== */}
      <section className="md-kit-sec">
        <div className="container container--wide md-kit">
          {/* Press Kit */}
          <div className="md-presskit">
            <h2 className="h2">Press Kit</h2>
            <p className="md-presskit__lead">
              Everything you need to know about Caladium Systems at your
              fingertips.
            </p>
            <div className="md-presskit__body">
              <div className="md-presskit__folder">
                <span className="md-folder">
                  <img
                    src={`${IMG}/Logo-caladium.png`}
                    alt="Caladium Press Kit"
                  />
                  <span className="md-folder__label">PRESS KIT</span>
                </span>
              </div>
              <ul className="md-files">
                {pressKit.map((f) => (
                  <li key={f.title}>
                    <span className="md-files__icon">
                      <Icon name={f.icon} size={20} />
                    </span>
                    <div className="md-files__text">
                      <strong>{f.title}</strong>
                      <span>{f.meta}</span>
                    </div>
                    <button type="button" className="md-files__dl" aria-label="Download">
                      <Icon name="download" size={16} />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <button type="button" className="btn btn--outline md-presskit__all">
              Download All <Icon name="download" size={15} />
            </button>
          </div>

          {/* Media Resources */}
          <div className="md-resources">
            <h2 className="h2">Media Resources</h2>
            <p className="md-resources__lead">
              Logos, images, videos and other resources for editorial use.
            </p>
            <div className="md-resources__grid">
              {resources.map((r) => (
                <div className="md-resource" key={r.title}>
                  <span
                    className="md-resource__icon"
                    style={{ color: r.color, borderColor: r.color }}
                  >
                    <Icon name={r.icon} size={28} />
                  </span>
                  <h3>{r.title}</h3>
                  <span className="md-resource__cta">{r.cta}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* =================== FEATURED VOICE + ENGAGEMENTS =================== */}
      <section className="md-voice-sec">
        <div className="container container--wide md-voice-row">
          <div className="md-voice">
            <img
              className="md-voice__photo"
              src={`${IMG}/Caladium_MD.png`}
              alt="Pradhyumna T Venkat"
            />
            <div className="md-voice__copy">
              <span className="eyebrow">Featured Voice</span>
              <p className="md-voice__quote">
                &ldquo;We are building an ecosystem where technology meets
                humanity to create experiences that spread joy and strengthen
                relationships.&rdquo;
              </p>
              <div className="md-voice__by">
                <strong>Pradhyumna T Venkat</strong>
                <span>Founder &amp; CEO, Caladium Systems</span>
              </div>
            </div>
          </div>

          <div className="md-engs">
            <header className="md-engs__head">
              <span className="md-engs__chip">
                <Icon name="users" size={18} />
              </span>
              <h2 className="h2">Speaking Engagements</h2>
            </header>
            <ul className="md-engs__list">
              {engagements.map((e) => (
                <li key={e.title}>
                  <div className="md-engs__date">
                    <span>{e.month}</span>
                    <strong>{e.day}</strong>
                  </div>
                  <div className="md-engs__text">
                    <h3>{e.title}</h3>
                    <span>{e.place}</span>
                  </div>
                  <a href="#detail" className="md-engs__link">
                    View Details <Icon name="arrow-right" size={13} />
                  </a>
                </li>
              ))}
            </ul>
            <a href="#all" className="md-engs__more">
              View All Engagements <Icon name="arrow-right" size={14} />
            </a>
          </div>
        </div>
      </section>

      {/* =================== NEWSLETTER =================== */}
      <section className="md-news-sub-sec">
        <div className="container container--wide">
          <div className="md-sub">
            <span className="md-sub__icon">
              <Icon name="send" size={22} />
            </span>
            <div className="md-sub__text">
              <h2>Stay Updated</h2>
              <p>
                Subscribe to get our latest news, press releases and updates on
                our journey of spreading joy.
              </p>
            </div>
            <form className="md-sub__form" onSubmit={onSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">
                Subscribe <Icon name="arrow-right" size={16} />
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
